import React from 'react';
import LearningPathView from '../components/learning-path/view/LearningPathView';

const OfflinePathPage = () => <LearningPathView source="offline" />;

export default OfflinePathPage;
